import { Vue, Component, Prop } from 'vue-property-decorator'

import { AvailableButtonsTypes } from '../types'

@Component
export class ButtonsConstructorProps extends Vue {
  @Prop({ type: Array }) readonly availableButtonsTypes!: AvailableButtonsTypes

  @Prop({ type: Number, default: 12 }) readonly buttonsRowsMax!: number

  @Prop({ type: Number, default: 8 }) readonly buttonsInRowMax!: number

  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean

  @Prop() buttonsHelpView!: any
}
